import type {
  InvalidLedgerClassificationExceptionResponse,
  InvalidLedgerQueryExceptionResponse,
  LedgerClassificationConflictExceptionResponse,
} from "@/openapi";
import { m } from "@/paraglide/messages";

const CLASSIFICATION_REASONS: Record<
  InvalidLedgerClassificationExceptionResponse["reason"],
  () => string
> = {
  NO_LEDGER_BINDING: m.ledger_error_no_binding,
  TARGET_NOT_IN_CATALOG: m.ledger_error_invalid_target,
  ACCOUNT_OUT_OF_SCOPE: m.ledger_error_account_out_of_scope,
};

const QUERY_REASONS: Record<
  InvalidLedgerQueryExceptionResponse["reason"],
  () => string
> = {
  NO_LEDGER_BINDING: m.ledger_error_no_binding,
  NO_LEDGER_QUERY: m.ledger_error_no_query,
  ORIGIN_UNAVAILABLE: m.ledger_error_origin_unavailable,
  IDENTIFIER_COLUMNS_INVALID: m.ledger_error_identifier_columns_invalid,
  YEAR_BIND_INVALID: m.ledger_error_year_bind_invalid,
  DUPLICATE_COLUMNS: m.ledger_error_duplicate_columns,
  MISSING_COLUMNS: m.ledger_error_missing_columns,
  INVALID_BOOKING_YEAR: m.ledger_error_invalid_booking_year,
  INVALID_IDENTIFIER: m.ledger_error_invalid_identifier,
  DUPLICATE_ACCOUNT_YEAR: m.ledger_error_duplicate_account_year,
  CHANGED_DURING_LOAD: m.ledger_error_changed_during_load,
};

export function ledgerClassificationReasonMessage(
  reason: InvalidLedgerClassificationExceptionResponse["reason"],
): string {
  return CLASSIFICATION_REASONS[reason]();
}

export function ledgerQueryReasonMessage(
  reason: InvalidLedgerQueryExceptionResponse["reason"],
): string {
  return QUERY_REASONS[reason]();
}

// the backend refuses the whole batch, so every row the user edited is still
// unsaved; naming the moved accounts tells them which ones to redo
export function ledgerClassificationConflictMessage(
  identifierKeys: LedgerClassificationConflictExceptionResponse["identifier_keys"],
): string {
  return m.ledger_error_classification_conflict({
    accounts: identifierKeys.join(", "),
  });
}
